'use client';;
import { useState, useCallback, Fragment } from 'react';
import Popover from '@mui/material/Popover';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  hoverable: {
    marginLeft: theme.spacing(0.5),
    color: theme.palette.text.secondary,
  },
  popover: {
    pointerEvents: 'none',
  },
  popoverContent: {
    padding: theme.spacing(1),
    pointerEvents: 'auto',
  },
}));

type Props = {
  children?: React.ReactNode;
  iconComponent?: React.ElementType;
};

const PopoverIcon = ({ children, iconComponent: IconComponent = InfoOutlinedIcon }: Props) => {
  const { classes } = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const handleOpen = useCallback(() => setOpen(true), []);
  const handleClose = useCallback(() => setOpen(false), []);

  return (
    <Fragment>
      <IconComponent
        fontSize="small"
        ref={setAnchorEl}
        onMouseEnter={handleOpen}
        onMouseLeave={handleClose}
        aria-haspopup="true"
        aria-owns="details-popover"
        className={classes.hoverable}
      />
      <Popover
        id='details-popover'
        anchorEl={anchorEl}
        open={open}
        className={classes.popover}
        classes={{
          paper: classes.popoverContent,
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={handleClose}
        slotProps={{
          paper: {
            onMouseEnter: handleOpen,
            onMouseLeave: handleClose,
          },
        }}
      >
        {children}
      </Popover>
    </Fragment>
  );
};

export default PopoverIcon;
